<script>
import baseMixin from '@/mixins/baseMixin'
import EmptyStateBlock from '../empty-state-block.vue'

export default {
  name: 'PresetSavedSuccessView',
  components: { EmptyStateBlock },
  mixins: [baseMixin],
  props: {
    presetForm: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <EmptyStateBlock
    icon="mdi-check-circle"
    :title="
      $t('general.orgFilter.dialog.saveSuccess.title', [presetForm.title])
    "
    :description="$t('general.orgFilter.dialog.saveSuccess.description')"
  >
    <template v-slot:button>
      <div>
        <v-btn text outlined class="mr-2" @click="$emit('back')">
          <v-icon left>mdi-arrow-left</v-icon> {{ $t('general.back') }}
        </v-btn>
        <v-btn text outlined color="primary" @click="$emit('apply')">
          {{ $t('general.orgFilter.dialog.saveSuccess.usePresetBtn') }}
        </v-btn>
      </div>
    </template>
  </EmptyStateBlock>
</template>
